import invert from './invert.js';
import escapeMap from './_escapeMap.js';
// Internal list of HTML entities for unescaping.
export default invert(escapeMap);
